<template>
  <div>
    <modal name="simple-task" height="auto">
      <div class="task-modal-head" v-if="task.reference">
        <div class="task-modal-close">
          <a @click="hideSimpleTask()"> &times; </a>
        </div>
        <div
          class="px-4 pt-5 px-md-4 pt-md-5 main-title-modal d-flex justify-content-between"
        >
          <p>
            {{ $t("task.view.createdBy") }}:
            {{ task.createdBy.firstName }}
            {{ task.createdBy.lastName }}
            ({{ formatDate(task.createdBy.creationDate) }})
          </p>
          <p v-if="task.dueDate">
            {{ $t("task.view.due") }}: {{ formatDate(task.dueDate) }}
          </p>
        </div>
        <div class="px-4 px-md-4 modal-head-description">
          <ul class="description-unorder">
            <li>
              <h3>{{ $t("task.view.description") }}</h3>
            </li>
            <li>
              <div :class="whichStatus">
                <select
                  class="peding-done-select"
                  v-model="whichStatus"
                  @change="updateStatus()"
                >
                  <option value="pending">{{ $t("global.pending") }}</option>
                  <option value="Done">{{ $t("global.done") }}</option>
                </select>
              </div>
            </li>
            <li v-if="!task.bulk">
              <span> Dernier changement du statut :&nbsp; </span>
              <span>
                {{ task.statusChangedBy.firstName }}
                {{ task.statusChangedBy.lastName }} &nbsp;
              </span>
              <span>
                ({{ formatStatusDate(task.statusChangedBy.timeStamp) }})
              </span>
            </li>
          </ul>
        </div>
        <div class="px-4 px-md-4 modal-description-btn d-flex">
          <button
            class="mx-1 mx-md-1 btn-label"
            v-for="(emp, index) in employees"
            :key="index"
          >
            {{ emp.firstName }} {{ emp.lastName }}
          </button>
        </div>
        <div
          v-if="task.fileName.length"
          class="px-4 file-upload-btn-wrapper"
          v-for="(file, index) in task.fileName"
          :key="index"
        >
          <div class="d-flex justify-content-between">
            <span>
              {{ file.length > 10 ? `${file.slice(0, 10)}...` : file }}
            </span>
            <img
              v-if="task.createdBy.createdById == user.reference"
              @click="removeFileAndUpdateTask(task, file)"
              class="cross-attachment"
              src="@/assets/images/times-circle-regular.svg"
            />
          </div>
          <button class="attachment-btn" @click="viewFile(file)">
            <i class="fas fa-eye"></i>
            {{ $t("task.fileAttached") }}
          </button>
        </div>

        <div
          class="px-4 my-4 px-md-4 my-md-3 modal-notifiction-btn d-flex justify-content-end"
          v-if="checkCreatedBy(task.createdBy)"
        >
          <button
            v-if="$route.path != '/personalTasks'"
            type="button"
            class="mx-1 mx-md-1 send-noti-btn"
            @click="sendNotification(notificationDescription)"
          >
            {{ $t("global.notification") }}
          </button>
          <button
            type="button"
            class="mx-1 mx-md-1 del-btn"
            @click="$emit('deleteTask', task.reference)"
          >
            {{ $t("task.view.delete") }}
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
          <button type="button" class="mx-md-1 edit-btn" @click="editTask()">
            {{ $t("task.view.edit") }}
            <img src="@/assets/images/edit.svg" />
          </button>
        </div>
        <div class="modal-description-pera" v-if="task.description">
          <p class="px-4 px-md-4" v-if="task.description">
            {{ task.description }}
          </p>
        </div>
        <div
          class="px-4 px-md-4 modal-comment-section"
          v-for="(comment, index) in computedComments"
          :key="index"
        >
          <div class="d-flex">
            <div class="modal-comment-profile">
              <p>
                {{ comment.user.firstName[0] }}{{ comment.user.lastName[0] }}
              </p>
            </div>
            <div class="modal-comment-text">
              <div class="d-flex justify-content-between">
                <div>
                  <h3>
                    {{ comment.user.firstName }} {{ comment.user.lastName }}
                  </h3>
                </div>
                <div class="multiple-files-wraper">
                  <div
                    v-if="comment.fileName"
                    class="file-upload-btn-wrapper mr-md-3"
                    v-for="(file, index) in comment.fileName"
                    :key="index"
                  >
                    <div class="d-flex justify-content-between">
                      <span>
                        {{
                          file.length > 10 ? `${file.slice(0, 10)}...` : file
                        }}
                      </span>
                      <img
                        v-if="comment.user.reference == user.reference"
                        @click="removeFile(comment, file, index)"
                        class="cross-attachment"
                        src="@/assets/images/times-circle-regular.svg"
                      />
                    </div>
                    <button class="attachment-btn" @click="viewFile(file)">
                      <i class="fas fa-eye"></i>
                      {{ $t("task.fileAttached") }}
                    </button>
                  </div>
                </div>
              </div>
              <p>
                {{ comment.comment }}
              </p>
            </div>
          </div>
        </div>
        <div class="px-4 px-md-4 modal-comment-section">
          <div class="d-flex">
            <div class="modal-comment-profile">
              <p>{{ user.firstName[0] }}{{ user.lastName[0] }}</p>
            </div>
            <div class="modal-comment-text">
              <h3>{{ user.firstName }} {{ user.lastName }}</h3>
              <textarea v-model="coment" :placeholder="$t('task.comment')">
              </textarea>
            </div>
          </div>
          <div class="uplord-and-submit-btn d-flex flex-column align-items-end">
            <div class="drop-zone">
              <dropzone
                @fileAdded="fileAdded"
                :remove="removeFlag"
                @removeFlag="setRemoveFlag"
                @removeFileFromTask="removeFileFromTask"
              />
            </div>
            <div>
              <button class="mx-md-1 comment-submit-btn" @click="saveComment()">
                {{ $t("task.submitComment") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import TimeUtils from '../../utils/TimeUtils';
import TaskHelper from '../../helper/TaskHelper';
import Dropzone from '../task/Dropzone';


export default {
  props: {
    task: {
      type: Object,
    },
    selectedEmployees: {
      type: Array,
    },
  },
  components: {
    Dropzone,
  },
  mounted() {
    this.user = this.$store.state.user.informations;
    this.$root.$on('simpleTaskView', (reference) => {
      this.fetchTask(reference);
    });
  },

  data() {
    return {
      user: {},
      coment: '',
      comments: [],
      comment: {
        user: {},
        fileName: [],
      },
      removeFlag: false,
      files: [],
      status: '',
    };
  },

  computed: {
    employees() {
      return this.selectedEmployees ? this.selectedEmployees : this.task.users;
    },

    whichStatus: {
      get() {
        return this.task.bulk ? this.employees[0].status : this.task.status;
      },

      set(value) {
        this.status = value;
      },
    },

    computedComments() {
      const references = [];
      const comments = this.task.bulk
        ? this.comments.filter((comment) => {
          references.push(comment.user.reference);
          return (
            comment.user.reference == this.employees[0].reference ||
              comment.user.commentTo == this.employees[0].reference
          );
        })
        : this.comments;
      return comments;
    },

    notificationDescription() {
      return `${this.task.createdBy.firstName} ${this.task.createdBy.lastName} 
      ${this.$t('task.notificationSentence')} : ${this.task.title}`;
    },
  },

  methods: {
    fetchTask(reference) {
      this.$services.task
        .managerCreatedTasks(`/task/${reference}`, '')
        .then((res) => {
          this.comments = res.data[0].comments;
        });
    },

    fileAdded(files) {
      this.files = files;
    },

    async viewFile(name) {
      const body = {
        name,
      };
      this.$services.task.readFile(body).then((res) => {
        if (res.status === 200) {
          window.open(res.data.image[0].url);
        }
      });
    },

    setRemoveFlag(flag) {
      this.removeFlag = flag;
    },

    removeFileFromTask(name) {
      const files = this.files.filter(file => file.name != name);
      this.files = files;
    },

    fileRemovedStatus(status) {
      if (status == 200) {
        this.$miniToastr.success('Fichier supprimé avec succès');
      } else {
        this.$miniToastr.success("Le fichier n'est pas supprimé");
      }
    },

    removeFileAndUpdateTask(task, name) {
      const files = task.fileName.filter(f => f != name);
      this.$services.task.deleteFile(name).then((res) => {
        this.fileRemovedStatus(res.status);
        if (res.status == 200) {
          task.fileName = files;
          TaskHelper.updateTask(task);
        }
      });
    },

    updateCommentWithFileName(coment, name, index) {
      this.computedComments[index].fileName = coment.fileName.filter(f => f != name);
      const comment = this.computedComments[index];
      this.$services.task
        .updateComment(comment.reference, comment)
        .then((res) => {});
    },

    removeFile(comment, name, index) {
      this.$services.task.deleteFile(name).then((res) => {
        this.fileRemovedStatus(res.status);
        if (res.status == 200) {
          if (
            comment.comment ==
            `${this.user.firstName} ${this.user.lastName} a téléchargé un fichier pour vous`
          ) {
            if (comment.fileName.length == 1) {
              this.$services.task
                .deleteComment(comment.reference)
                .then((res) => {
                  this.computedComments.splice(index, 1);
                });
            } else {
              this.updateCommentWithFileName(comment, name, index);
            }
          } else {
            this.updateCommentWithFileName(comment, name, index);
          }
        }
      });
    },

    editTask() {
      this.$modal.hide('simple-task');
      this.$modal.show('edit-task');
      this.$root.$emit('editTask', this.task);
    },

    formatDate(date) {
      return date && TimeUtils.dayMonYear(date);
    },

    formatStatusDate(date) {
      return TimeUtils.dayMonYearTime(date);
    },

    checkCreatedBy(obj) {
      return obj.createdById == this.user.reference;
    },

    statusTranslation(status) {
      return status == 'pending' ? 'À faire' : 'Terminé';
    },

    async updateStatus() {
      const st = await TaskHelper.updateStatus(
        this.task,
        this.status,
        this.user,
        this.employees,
      );
      // employees will help in bulk task to seefor which emp to update status
      if (st) {
        this.$miniToastr.success(this.$t('global.updateToaster'));
        const desc = `${this.user.firstName} ${this.user.lastName} 
        ${this.$t('task.statusSentence')} ${this.statusTranslation(this.status)} pour : 
        ${this.task.title}`;
        this.sendNotification(desc);
      } else {
        this.$miniToastr.error(this.$t('global.noUpdateToaster'));
      }
    },

    async sendNotification(description) {
      const users = this.employees.filter(emp => emp.reference != this.user.reference);
      const status = await TaskHelper.sendNotification(
        this.task,
        users,
        description,
      );
      status == 200
        ? this.$miniToastr.success(this.$t('global.notificationToaster'))
        : this.$miniToastr.error(this.$t('global.noNotificationToaster'));
    },

    async saveComment() {
      this.comment.taskId = this.task.reference;
      this.comment.user.reference = this.user.reference;
      this.comment.user.firstName = this.user.firstName;
      this.comment.user.lastName = this.user.lastName;
      if (
        this.task.bulk &&
        this.task.createdBy.createdById == this.user.reference
      ) {
        this.comment.user.commentTo = this.employees[0].reference;
      }
      this.comment.comment =
        this.coment ||
        `${this.user.firstName} ${this.user.lastName} a téléchargé un fichier pour vous`;
      if (this.files.length) {
        const form = new FormData();
        const time = new Date().valueOf().toString();
        const unique = time.slice(time.length / 2, time.length - 1);
        this.comment.fileName = [];
        this.files.forEach((file) => {
          form.append('file', file, unique.concat(file.name));
          this.comment.fileName.push(unique.concat(file.name));
        });
        this.$services.task.uploadFile(form).then((res) => {
          if (res.status == 200) {
            this.removeFlag = true;
          }
        });
      }
      await this.$services.task.saveComment(this.comment).then((res) => {
        if (res.status == 200) {
          this.coment = '';
          this.comments.push(res.data);
          const desc = `${this.user.firstName} ${this.user.lastName} a ajouté un commentaire sur cette tâche : ${this.task.title}`;
          this.sendNotification(desc);
        } else {
          this.$miniToastr.error(this.$t('task.commentNotSaved'));
        }
      });
    },

    hideSimpleTask() {
      if (this.$route.params.reference) {
        this.$modal.hide('simple-task');
        this.$router.back(-1);
      } else {
        this.$modal.hide('simple-task');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.file-upload-btn-wrapper {
  position: relative;
  display: inline-block;
}
.multiple-files-wraper {
  width: 65%;
  display: block;
  padding-bottom: 10px;
  text-align: end;
}
.modal-description-btn {
  .btn-label {
    background-color: #e8e9f0;
    display: inline-block;
    padding: 4px 20px 4px 20px;
    border: 0;
    border-radius: 3px;
    font-family: "SF-Pro-Text";
    color: #303778;
    font-weight: 500;
    font-size: 14px;
    outline: none;
    height: 35px;
    margin-bottom: 10px;
    position: relative;
    @media (min-width: 320px) and (max-width: 600px) {
      font-size: 12px;
    }
    .close-icon-btn {
      position: absolute;
      right: 12px;
      top: 0;
      width: 15px;
      line-height: 35px;
      text-align: center;
      font-size: 15px;
      font-weight: 700;
      border-left: 1px solid #d8cfcf;
      border-radius: 0;
      height: 35px;
      padding-left: 8px;
      color: #9e8d8d;
    }
  }
}
.cross-attachment {
  width: 20px;
  text-align: center;
  position: relative;
  left: 5px;
  top: 3px;
  border-radius: 5px;
  background-color: #eee;
  cursor: pointer;
}
.drop-zone {
  width: 85%;
}
.task-modal-head {
  position: relative;
  min-height: 550px;
  height: 550px;
  overflow-y: auto;
  .task-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
  .modal-head-description {
    .description-unorder {
      margin: 0;
      padding: 0;
    }
    li {
      display: inline-block;
      margin-right: 5px;
      ul {
        padding-left: 25px;
        li {
          padding: 0px;
          margin: 0px;
        }
      }
      h3 {
        font-size: 26px;
        font-family: "SF-Pro-Text";
        color: #212529;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 17px;
        }
      }
      span {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }

  .modal-description-pera {
    background-color: #f6f8ff;
    padding: 20px 0;
    p {
      font-size: 16px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 14px;
      }
    }
  }
  .modal-comment-section {
    box-shadow: 0 0 2px 0 #b9bbd1;
    margin-bottom: 7px;
    padding: 18px 0;
    .modal-comment-profile {
      background-color: #b9bbd1;
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-radius: 60px;
      margin-top: -1px;
      margin-bottom: 12px;
      @media (min-width: 320px) and (max-width: 600px) {
        height: 40px;
        width: 40px;
        border-radius: 40px;
        margin: 10px 10px 0 0;
      }
      p {
        margin: 0;
        font-size: 20px;
        color: #fff;
        font-family: "SF-Pro-Text";
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 15px;
        }
      }
    }
    .modal-comment-text {
      width: 85%;
      margin-left: 20px;
      @media (min-width: 320px) and (max-width: 600px) {
        margin-left: 5px;
      }
      h3 {
        margin: 0;
        font-size: 20px;
        font-family: "SF-Pro-Text";
        color: #303778;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 16px;
        }
      }
      p {
        text-align: justify;
        line-height: normal;
        color: #212529;
        font-family: "SF-Pro-Text";
        margin: 0;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 12px;
        }
      }
      textarea {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        border: solid 1px #becad6;
        resize: none;
        outline: none;
        padding: 10px;
        @media (min-width: 320px) and (max-width: 600px) {
          margin-bottom: 20px;
        }
      }
    }
    .comment-submit-btn {
      background-color: #4f78e1;
      height: 35px;
      color: #fff;
      margin-top: 10px;
      font-family: "SF-Pro-Text";
      outline: none;
      padding: 4px 15px;
      border: none;
      margin-left: 10px;
      border-radius: 3px;
    }
  }
}
.modal-notifiction-btn {
  .send-noti-btn {
    border: 1px solid #4f78e1;
    background-color: transparent;
    padding: 4px 15px;
    border-radius: 3px;
    color: #4f78e1;
    font-family: "SF-Pro-Text";
    font-weight: 500;
    font-size: 14px;
    outline: none;
    @media (min-width: 320px) and (max-width: 600px) {
      font-size: 12px;
      padding: 3px 10px;
    }
  }
}
.modal-description-pera {
  background-color: #f6f8ff;
  padding: 20px 0;
  p {
    font-size: 16px;
    font-family: "SF-Pro-Text";
    color: #212529;
    @media (min-width: 320px) and (max-width: 600px) {
      font-size: 14px;
    }
  }
}
.del-btn {
  background-color: #fddad5;
  padding: 4px 15px;
  border-radius: 3px;
  color: #fc452d;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  border: 0;
  font-size: 14px;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
}
.edit-btn {
  border: 1px solid #becad6;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 3px;
  color: #5a6169;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-size: 14px;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
  img {
    width: 15px;
    vertical-align: sub;
  }
}
.attachment-btn {
  border: solid 1px #becad6;
  background-color: #ffffff;
  padding: 4px 15px;
  border-radius: 3px;
  font-size: 11px;
  font-family: "SF-Pro-Text";
  outline: none;
  color: #5a6169;
}
.Done {
  position: relative;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    width: 120px;
    object-fit: contain;
    border-radius: 3px;
    border: none;
    background-color: transparent !important;
    color: #17c671 !important;
    font-family: "SF-Pro-Text";
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 14px;
    margin: 0 auto !important;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-done.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
  width: 120px;
  height: 30px;
  object-fit: contain;
  border-radius: 3px;
  border: solid 1px #17c671;
  background-color: rgba(23, 198, 113, 0.24) !important;
  color: #17c671 !important;
  font-family: "SF-Pro-Text";
  box-shadow: none !important;
  font-size: 11px;
}
.pending {
  position: relative;
  width: 120px;
  height: 30px;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    object-fit: contain;
    border-radius: 3px;
    border: solid 1px #ffb400;
    background-color: rgba(255, 180, 0, 0.24) !important;
    color: #ffb400 !important;
    font-family: "SF-Pro-Text";
    margin: 0 auto;
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 20px;
    width: 120px;
  }
  &:before {
    display: none;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-pending.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
}
</style>
